import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "../auth";

export const DashboardShell = ({ title, tabs, active, onTab, children }) => {
  const { user, doLogout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-100 flex">
      {/* Sidebar */}
      <aside className={`fixed lg:static inset-y-0 left-0 z-40 w-64 bg-[#0A1128] text-white flex flex-col transition-transform ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
        <div className="p-6 border-b border-white/10"><Logo light /></div>
        <nav className="flex-1 p-4 space-y-1 overflow-y-auto no-scrollbar">
          {tabs.map((tb) => (
            <button
              key={tb.key}
              data-testid={`dash-tab-${tb.key}`}
              onClick={() => { onTab(tb.key); setOpen(false); }}
              className={`w-full flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-medium transition-colors ${active === tb.key ? "bg-white/10 text-white" : "text-white/60 hover:text-white hover:bg-white/5"}`}
            >
              <tb.icon className="h-4 w-4" /> {tb.label}
            </button>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <div className="text-xs text-white/40 mb-2 px-2 truncate">{user?.email}</div>
          <button onClick={() => navigate("/valida")} className="w-full flex items-center gap-2 text-sm text-secondary hover:text-white px-2 py-1.5 font-semibold">✓ Valida QR Voucher</button>
          <button onClick={() => navigate("/")} className="w-full text-left text-sm text-white/60 hover:text-white px-2 py-1.5">← Torna al sito</button>
          <button data-testid="sidebar-logout" onClick={async () => { await doLogout(); navigate("/"); }} className="w-full flex items-center gap-2 text-sm text-white/60 hover:text-white px-2 py-1.5"><LogOut className="h-4 w-4" /> Esci</button>
        </div>
      </aside>
      {open && <div className="fixed inset-0 z-30 bg-black/40 lg:hidden" onClick={() => setOpen(false)} />}

      {/* Main */}
      <div className="flex-1 min-w-0">
        <header className="sticky top-0 z-20 bg-white border-b border-slate-200 px-4 sm:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button className="lg:hidden" onClick={() => setOpen(true)}><Menu className="h-5 w-5" /></button>
            <h1 className="font-heading font-semibold text-lg text-slate-900">{title}</h1>
          </div>
        </header>
        <div className="p-4 sm:p-8">{children}</div>
      </div>
    </div>
  );
};

export const StatCard = ({ label, value, sub, accent }) => (
  <div className="bg-white rounded-xl border border-slate-200 p-5" data-testid={`stat-${label}`}>
    <div className="text-xs font-bold uppercase tracking-wide text-slate-400">{label}</div>
    <div className={`mt-2 text-2xl font-heading font-bold ${accent ? "text-primary" : "text-slate-900"}`}>{value}</div>
    {sub && <div className="text-xs text-slate-400 mt-1">{sub}</div>}
  </div>
);
